import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  border-top: 1px solid ${props => (props.brand ? props.theme.colors.base : props.theme.colors.secondary)};
  border-right: 1px solid ${props => (props.brand ? props.theme.colors.base : props.theme.colors.secondary)};
  border-bottom: 4px solid ${props => (props.brand ? props.theme.colors.base : props.theme.colors.secondary)};
  border-left: 4px solid ${props => (props.brand ? props.theme.colors.base : props.theme.colors.secondary)};
  appearance: none;
  padding: 0.8rem 2.25rem;
  background-color: transparent;
  color: ${props => (props.diapositive ? "white" : props.theme.colors.base)};
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => (props.brand ? props.theme.colors.base : props.theme.colors.secondary)};
    color: ${props =>
      props.diapositive ? props.theme.colors.base : "white"};
  }
`;

const Button = props => {
  return (
    <div>
      {props.onButtonClick ? (
        <StyledButton
          onClick={() => props.onButtonClick(props.src)}
          diapositive={props.diapositive}
        >
          {props.title}
        </StyledButton>
      ) : (
        <StyledButton diapositive={props.diapositive} brand={props.brand}>
          {props.title}
        </StyledButton>
      )}
    </div>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js